import { strtr } from "./utils";

// Funzione per convertire un ArrayBuffer in una stringa
function arrayBufferToString(buffer) {
  let decoder = new TextDecoder();
  return decoder.decode(buffer);
}

// Funzione per decriptare con AES-256-CBC in JavaScript
async function decrypt_v1(encryptedData, key = 'grind') {
  // Decodifica il dato base64
  const decodedData = atob(encryptedData); // Decodifica Base64

  // Separiamo i dati cifrati dall'IV
  const parts = decodedData.split('::');
  const encryptedText = parts[0]; // Dati cifrati
  const ivBase64 = parts[1]; // IV (Base64)

  // Convertiamo l'IV (in Base64) in un array di byte
  const ivBytes = new Uint8Array(ivBase64.split('').map(char => char.charCodeAt(0)));
  console.log(ivBytes);

  // Convertiamo il testo cifrato in un array di byte (Uint8Array)
  const encryptedBytes = new Uint8Array(encryptedText.split('').map(char => char.charCodeAt(0)));

  // Generiamo la chiave con SHA-256 (per AES-256)
  const keyBuffer = await crypto.subtle.importKey(
      'raw',
      new TextEncoder().encode(key), // Codifica la chiave in formato ArrayBuffer
      { name: 'AES-CBC' },
      false,
      ['decrypt']
  );

  try {
      // Decrittografiamo i dati
      const decryptedDataBuffer = await crypto.subtle.decrypt(
          { name: 'AES-CBC', iv: ivBytes },
          keyBuffer,
          encryptedBytes
      );

      // Decodifichiamo i dati in formato stringa (UTF-8)
      const decoder = new TextDecoder();
      const decryptedData = decoder.decode(decryptedDataBuffer);
      
      // Restituiamo i dati come oggetto (l'array originale)
      return JSON.parse(decryptedData);
  } catch (e) {
      throw new Error("Errore durante la decrittografia: " + e.message);
  }
}


const icLib = {
  myEncodeDecodeLabels: {
    v1: 0x39,
    x3: 0x21,
  },
  decrypt_v1,
  clean_encoded($str) {
    return strtr($str, { "/": "[1]", "+": "[2]", "=": "[3]" });
  },
  clean_decoded($str) {
    return strtr($str, { "[1]": "/", "[2]": "+", "[3]": "=" });
  },
  __d(encodedString, parse = true) {
    encodedString = this.clean_decoded(encodedString);
    // console.log('%c decode', 'background:yellow;font-weight:bold', encodedString);
    var token = this.getMyEncodeDecodeToken(encodedString);
    if (token === false) return false;
    encodedString = encodedString.substr(2);
    if (encodedString.length === 0) return false;
    var string = atob(encodedString);
    var crc = string.substr(-4);
    string = string.substr(0, string.length - 4);
    string = this.myEncodeDecode(string, token);
    if (crc !== this.myCrc(string)) return false;
    string = string.replace(/u\d{1}\w{0,5}/g, (string) => "\u005c" + string);
    return JSON.parse(string);
  },
  __e(rawJsonPreset, label = "x3") {
    const token = this.getMyEncodeDecodeToken(label);
    if (!token) return false;
    const cleanJSON = rawJsonPreset.replace(/[\u007F-\uFFFF]/g, function (chr) {
      return "\\u" + ("0000" + chr.charCodeAt(0).toString(16)).substr(-4);
    });
    /** checksum di `cleanJSON` che è JSON stringificato  */
    const crc = this.myCrc(cleanJSON);
    let encoded = this.myEncodeDecode(cleanJSON, token);
    encoded = encoded.concat(crc);
    return this.clean_encoded(label + btoa(encoded));
    // return (label + btoa(encoded)).concat(crc);
  },
  myCrc(string) {
    if (typeof string !== "string") return false;
    var len = string.length;

    var crc0 = 0;
    var crc1 = 0;
    var crc2 = 0;
    var crcAll = 0;
    for (var index = 0; index < len; index++) {
      var v = string.charCodeAt(index);
      switch (index % 3) {
        case 0:
          crc0 += v;
          break;
        case 1:
          crc1 += v;
          break;
        case 2:
          crc2 += v;
          break;
        default:
          break;
      }
      crcAll += v;
    }
    var crc = "";
    crc = crc.concat(String.fromCharCode(crc0 % 128));
    crc = crc.concat(String.fromCharCode(crc1 % 128));
    crc = crc.concat(String.fromCharCode(crc2 % 128));
    crc = crc.concat(String.fromCharCode(crcAll % 128));
    return crc;
  },
  getMyEncodeDecodeToken(string) {
    const label = string.substr(0, 2);
    if (!this.myEncodeDecodeLabels[label]) return false;
    return this.myEncodeDecodeLabels[label];
  },
  myEncodeDecode(string, token = 0) {
    let processed = "";
    for (let i = 0; i < string.length; i++) {
      let a = string.charCodeAt(i);
      let b = a ^ token; // bitwise XOR with any number, e.g. 123

      processed = processed + String.fromCharCode(b);
    }
    return processed;
  },
};
export default icLib;

if (window.location.href.indexOf(".local") || process.env.NODE_ENV === 'development') {
  window.icLib = icLib;
}
